import Relay from 'react-relay/classic';
import getRelayQueries from 'react-relay/lib/getRelayQueries';
import RelayQueryRequest from 'react-relay/lib/RelayQueryRequest';

import { relayLocalNetworkLayer } from '../../../../helper/relayEnvironment';
import LearnerViewCardsRoute from '../../../queries/LearnerViewCardsRoute';
import { fetchLearnerOfferRemotely } from '../../../../helper/LearningSpaceServices/fetchOffer';
import { LearnerViewCardsRC } from '..';
import { blockUserInteraction } from '../../../../helper/blockUserInteractionHelper';

export async function fetchRelayQueryForCourse(courseId, userId) {
  const userCourseRoute = new LearnerViewCardsRoute({ courseId, userId, resolveLocally: true });
  const querySet = getRelayQueries(LearnerViewCardsRC, userCourseRoute);
  const queryRoot = querySet.rootQ;
  const request = new RelayQueryRequest(queryRoot);

  relayLocalNetworkLayer.sendQueries([request]);

  const payload = await request.getPromise();
  Relay.Store.getStoreData().handleQueryPayload(queryRoot, payload.response);
}

export async function refetchCourseAndUpdateRelayStore(courseId, userId, { overwriteStates } = {}) {
  blockUserInteraction(true, '');
  await fetchLearnerOfferRemotely(courseId, userId, overwriteStates);
  await fetchRelayQueryForCourse(courseId, userId);
  blockUserInteraction(false);
}
